import React, { useReducer } from "react";
import { reducer, initialState } from "./reducer";

const contextName = "Emeterai";
const StateContext = React.createContext();
const DispatchContext = React.createContext();

export function useEmeteraiState() {
  const context = React.useContext(StateContext);
  if (context === undefined) {
    throw new Error(
      `useAuthState must be used within a ${contextName}Provider`
    );
  }
  return context;
}

export function useEmeteraiDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      `useEmeteraiState must be used within a ${contextName}Provider`
    );
  }
  return context;
}

export const EmeteraiProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};
